const request = require('./request')

export function insert(...args) {
	return request.post(`/users/insert`, ...args)
}

export function remove(...args) {
	return request.post(`/users/remove`, ...args)
}

export function list(...args) {
	return request.get(`/users/list`, ...args)
}

export function update(...args) {
	return request.post(`/users/update`, ...args)
}

export function login(...args) {
	return request.post(`/users/login`, ...args)
}

export function check(...args) {
	return request.post(`/users/check`, ...args)
}